import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="fixed bottom-0 left-0 right-0 z-[1000] bg-orangeBrand text-white text-center shadow-[0_-2px_8px_rgba(0,0,0,0.15)] px-4 py-2 sm:py-3 backdrop-blur-md">
      <p className="text-sm sm:text-base font-medium">
        © {new Date().getFullYear()} FonteneLunsj – Alle rettigheter
        forbeholdt.
      </p>

      <div className="footer-links mt-1 text-xs sm:text-sm space-x-2">
        <a
          href="/personvern"
          className="text-white hover:text-orangeHover transition"
        >
          Personvern
        </a>
        <span>|</span>
        <a href="/om" className="text-white hover:text-orangeHover transition">
          Om oss
        </a>
        <span>|</span>
        <a
          href="/kontakt"
          className="text-white hover:text-orangeHover transition"
        >
          Kontakt
        </a>
      </div>
    </footer>
  );
};

export default Footer;
